import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/routeTemplates";
import List from "./list";
import Show from "./show";

const RouteTemplates = (props) => {
    const { match, location, history } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => <List {...props} nofilter isTable transition="full" title="Шаблоны маршрутов" />}
                />
                <Route
                    path={`${rootUrl}/:id`}
                    render={(rest) => <Show {...rest} title="Шаблон маршрута" back={back} source={source} />}
                />
            </Switch>
        </div>
    );
};

export default RouteTemplates;
